import React, { useEffect} from "react";
import OtpInput from "react-otp-input";


export default function InputOtp({submitHandler, code, setCode,phoneNumber,setOpenModal}) {
  // const [otpCode, setOtpCode] = useState("");
  const handleChange = (chars) => {
     
    setCode({
    otpCode: chars
  })
 
};

useEffect(()=>{ 
 if (code?.otpCode?.toString().length === 4)  {
    submitHandler()
    }
},[code])

 
  return (
    <div dir="ltr" className="flex flex-col justify-center gap-6 z-50">

      <OtpInput
        value={code?.otpCode}
        onChange={ handleChange}
        shouldAutoFocus={true}
        numInputs={4}
        inputType="number"
        renderSeparator={<span style={{ width: "16px" }}> </span>}
        inputStyle={{
          border: "1px solid transparent",
          borderRadius: "60px",
          width: "47px",
          height: "68px",
          fontSize: "35px",
          color: "#000",
          fontWeight: "400",
          caretColor: "white",
        }}
        focusStyle={{
          border: "1px solid #CFD3DB",
          outline: "none",
        }}
        renderInput={(props) => <input {...props} />}
      />
    </div>
  );
}
